(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ako-konfigurator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFinder(root) {
      if (!root || root.dataset.akoReady === '1') return;
      root.dataset.akoReady = '1';
      var options = root.querySelectorAll('[data-ako-option]');
      var products = root.querySelectorAll('[data-ako-product]');
      var countEl = root.querySelector('[data-ako-count]');
      var resetEl = root.querySelector('[data-ako-reset]');
      var emptyEl = root.querySelector('[data-ako-empty]');
      var resultsEl = root.querySelector('[data-ako-results]');

      function selectedTags() {
        var tags = [];
        root.querySelectorAll('[data-ako-option][aria-pressed="true"]').forEach(function (b) { tags.push(b.dataset.tag); });
        return tags;
      }
      function apply() {
        var tags = selectedTags();
        var visible = 0;
        products.forEach(function (card) {
          var ptags = (card.dataset.tags || '').split(',');
          var match = tags.every(function (t) { return ptags.indexOf(t) !== -1; });
          card.hidden = !match; if (match) visible++;
        });
        if (resetEl) resetEl.hidden = tags.length === 0;
        if (countEl) countEl.textContent = tags.length === 0 ? '' : visible + (visible === 1 ? ' passende Markise' : ' passende Markisen');
        if (emptyEl && resultsEl) {
          var noHits = tags.length > 0 && visible === 0;
          emptyEl.hidden = !noHits;
          resultsEl.style.display = noHits ? 'none' : '';
        }
      }
      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pressed = btn.getAttribute('aria-pressed') === 'true';
          root.querySelectorAll('[data-ako-option][data-step="' + btn.dataset.step + '"]').forEach(function (sib) { sib.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
          apply();
        });
      });
      if (resetEl) resetEl.addEventListener('click', function () {
        options.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        apply();
      });
      apply();
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-ako-finder]').forEach(initFinder); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
